import { Page } from '@/core/architecture'

import { OfficialInformationDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * OfficialInformationDetail Page
 * Implemented as a practical sample.
 */
export const OfficialInformationDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <OfficialInformationDetailTemplate state={state} {...actions} />
}
